import { useState, useEffect } from 'react'

function useChart(chartRef) {
  const [chart, setChart] = useState()

  useEffect(() => {
    setChart(chartRef.current.chartComponent.current.chart)

    return () => {
      if (chart) chart.destroy()
    }
  }, [chartRef])

  return chart
}

export default useChart
